const formatDate = (date: Date): string => {
  const pad = (number: number): string => number.toString().padStart(2, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // Months are zero-based
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

/**
 * Formats a value for display in a table cell, converting it to a string.
 * Dates are formatted as "DD/MM/YYYY HH:MM", while numbers and booleans are
 * converted directly to strings. Invalid or unsupported values return an empty string.
 * @param value - The value to format (string, number, boolean, or other).
 * @returns A formatted string representation of the value.
 */
const formatCell = (value: unknown): string => {
  if (typeof value === "number" || typeof value === "boolean") {
    return value.toString();
  }

  if (typeof value === "string") {
    const normalizedValue = value.replace(",", ".").trim();
    const numericValue = Number(normalizedValue);
    if (!isNaN(numericValue)) {
      return value;
    }

    if (value.includes("/")) {
      return value;
    }

    const parsedDate = new Date(value);
    if (!isNaN(parsedDate.getTime())) {
      return formatDate(parsedDate);
    }
    return value;
  }

  return "";
};

export default formatCell;
